// NJC Report Type Configurations
export const REPORT_TYPES = [
  { value: "NJC/MCPJ/3C", label: "NJC/MCPJ/3C" },
  { value: "NJC/MCPJ/4_INDV", label: "NJC/MCPJ/4 (INDV JUDGES)" },
  { value: "NJC/MCPJ/4", label: "NJC/MCPJ/4" },
  { value: "NJC/MCPJ/5", label: "NJC/MCPJ/5" },
];

// Dummy data for NJC/MCPJ/3C (existing report)
export const getDummyData_3C = () => [
  {
    case_Type: "Civil",
    previousQuarterScheduled: 150,
    currentQuarterUnconcluded: 75,
    totalCount: 225,
    casesWithMultipleClaimants: 45,
    casesWithStruckout: 20,
    interlocContested: 30,
    interlocNotContested: 25,
    casesTotalDispose: 120,
    pendingCases: 105,
  },
  {
    case_Type: "Criminal",
    previousQuarterScheduled: 200,
    currentQuarterUnconcluded: 100,
    totalCount: 300,
    casesWithMultipleClaimants: 60,
    casesWithStruckout: 30,
    interlocContested: 40,
    interlocNotContested: 35,
    casesTotalDispose: 165,
    pendingCases: 135,
  },
  {
    case_Type: "Commercial",
    previousQuarterScheduled: 80,
    currentQuarterUnconcluded: 40,
    totalCount: 120,
    casesWithMultipleClaimants: 25,
    casesWithStruckout: 10,
    interlocContested: 15,
    interlocNotContested: 12,
    casesTotalDispose: 62,
    pendingCases: 58,
  },
];

// Dummy data for NJC/MCPJ/4 - List of all contested cases and judgments
export const getDummyData_4 = () => [
  {
    caseType: "Civil",
    suitNumber: "ID/3885GCM/2025",
    dateFiled: "12 Sept, 2024",
    assignedDate: "12 Sept, 2024",
    hearingDate: "12 Sept, 2024",
    judgementDate: "12 Sept, 2024",
    duration: "0 years, 0 months, 0 days",
    witnessCount: 0,
    remarks: "",
  },
  {
    caseType: "Civil",
    suitNumber: "ID/3886GCM/2025",
    dateFiled: "15 Sept, 2024",
    assignedDate: "15 Sept, 2024",
    hearingDate: "15 Sept, 2024",
    judgementDate: "15 Sept, 2024",
    duration: "0 years, 0 months, 0 days",
    witnessCount: 2,
    remarks: "",
  },
  {
    caseType: "Criminal",
    suitNumber: "CR/1234GCM/2025",
    dateFiled: "20 Sept, 2024",
    assignedDate: "20 Sept, 2024",
    hearingDate: "20 Sept, 2024",
    judgementDate: "20 Sept, 2024",
    duration: "0 years, 0 months, 0 days",
    witnessCount: 3,
    remarks: "",
  },
  {
    caseType: "Commercial",
    suitNumber: "COM/5678GCM/2025",
    dateFiled: "25 Sept, 2024",
    assignedDate: "25 Sept, 2024",
    hearingDate: "25 Sept, 2024",
    judgementDate: "25 Sept, 2024",
    duration: "0 years, 0 months, 0 days",
    witnessCount: 1,
    remarks: "",
  },
  {
    caseType: "Civil",
    suitNumber: "ID/7890GCM/2025",
    dateFiled: "28 Sept, 2024",
    assignedDate: "28 Sept, 2024",
    hearingDate: "28 Sept, 2024",
    judgementDate: "28 Sept, 2024",
    duration: "0 years, 0 months, 0 days",
    witnessCount: 0,
    remarks: "",
  },
];

// Dummy data for NJC/MCPJ/5 - List of all pending cases with case age
export const getDummyData_5 = () => [
  {
    caseType: "Civil",
    suitNumber: "ID/3885GCM/2025",
    dateFiled: "12 Sept, 2024",
    assignedDate: "12 Sept, 2024",
    hearingDate: "12 Sept, 2024",
    caseAge: "0 years, 0 months, 0 days",
    remarks: "",
  },
  {
    caseType: "Civil",
    suitNumber: "ID/4567GCM/2024",
    dateFiled: "05 Jan, 2024",
    assignedDate: "05 Jan, 2024",
    hearingDate: "05 Jan, 2024",
    caseAge: "0 years, 11 months, 19 days",
    remarks: "",
  },
  {
    caseType: "Criminal",
    suitNumber: "CR/8901GCM/2023",
    dateFiled: "15 March, 2023",
    assignedDate: "15 March, 2023",
    hearingDate: "15 March, 2023",
    caseAge: "1 year, 9 months, 9 days",
    remarks: "",
  },
  {
    caseType: "Commercial",
    suitNumber: "COM/2345GCM/2024",
    dateFiled: "20 June, 2024",
    assignedDate: "20 June, 2024",
    hearingDate: "20 June, 2024",
    caseAge: "0 years, 6 months, 4 days",
    remarks: "",
  },
  {
    caseType: "Civil",
    suitNumber: "ID/6789GCM/2024",
    dateFiled: "10 April, 2024",
    assignedDate: "10 April, 2024",
    hearingDate: "10 April, 2024",
    caseAge: "0 years, 8 months, 14 days",
    remarks: "",
  },
];

// Function to get dummy data based on report type
export const getDummyDataByType = (reportType) => {
  switch (reportType) {
    case "NJC/MCPJ/3C":
      return getDummyData_3C();
    case "NJC/MCPJ/4":
    case "NJC/MCPJ/4_INDV":
      return getDummyData_4();
    case "NJC/MCPJ/5":
      return getDummyData_5();
    default:
      return [];
  }
};
